/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CDKModule} from '../../cdk.module';
import {MaterialModule} from '../../material.module';
import {TableBoviclicAnimalsComponent} from './table-boviclic-animals/table-boviclic-animals.component';
import {SelectsModule} from '../selects/selects.module';
import {InputsModule} from '../inputs/inputs.module';
import {DialogHelper} from '../../_helpers/dialog-helper';
import {TableValidateAnimalsComponent} from './table-validate-animals/table-validate-animals.component';
import {TableRemovalAnimalsComponent} from './table-removal-animals/table-removal-animals.component';
import {ServicesModule} from '../../_services/services.module';
import {DisplaysModule} from '../displays/displays.module';
import {TableHistoryAnimalsComponent} from './table-history-animals/table-history-animals.component';
import {TablePendingAnimalsComponent} from './table-pending-animals/table-pending-animals.component';

@NgModule({
  declarations: [
    TableBoviclicAnimalsComponent,
    TableHistoryAnimalsComponent,
    TablePendingAnimalsComponent,
    TableRemovalAnimalsComponent,
    TableValidateAnimalsComponent
  ],

  exports: [
    TableBoviclicAnimalsComponent,
    TableHistoryAnimalsComponent,
    TablePendingAnimalsComponent,
    TableRemovalAnimalsComponent,
    TableValidateAnimalsComponent
  ],
  imports: [
    CDKModule,
    CommonModule,
    DisplaysModule,
    FormsModule,
    InputsModule,
    MaterialModule,
    ReactiveFormsModule,
    SelectsModule,
    ServicesModule
  ],
  providers: [
    DialogHelper
  ]
})

export class TablesModule {
}
